import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

import computeFullStatusHelper from "~/helpers/submission/computeFullStatus"

const initialState = function () {
  return {
    submissions: {},
    submissions_by_status: {
      Se: [],
      Wa: [],
      Wc: [],
      Fn: [],
      Ex: [],
    },
    fetched_status: [],
    submission_count: 0,
    loading: false,
  }
}

export default {
  state: initialState,
  mutations: {
    ADD_FETCHED_STATUS: function (state, status) {
      state.fetched_status.push(status)
    },
    MERGE_SUBMISSIONS_FROM_BATCH: function (state, { batch, status }) {
      const merge_arr = []

      for (let key in batch) merge_arr.push(batch[key].id)

      for (let id in batch) batch[id] = computeFullStatusHelper(batch[id])
      Vue.set(state.submissions_by_status, status, [
        ...state.submissions_by_status[status],
        ...merge_arr,
      ])
      Vue.set(state, "submissions", { ...state.submissions, ...batch })
      state.submission_count += merge_arr.length
    },
    REMOVE_SUBMISSION: function (state, { submission_id, last_status }) {
      if (!last_status) last_status = "Se"
      const last_status_index = state.submissions_by_status[
        last_status
      ].indexOf(submission_id)

      Vue.delete(state.submissions, submission_id)
      state.submission_count--
      state.submissions_by_status[last_status].splice(last_status_index, 1)
    },
    ADD_SUBMISSION: function (state, submission) {
      if (typeof submission.status_history === "string")
        submission.status_history = JSON.parse(submission.status_history)
      if (submission.pk) submission.id = submission.pk
      if (
        !state.submissions_by_status[submission.status].includes(submission.id)
      ) {
        Vue.set(
          state.submissions,
          submission.id,
          computeFullStatusHelper(submission)
        )
        state.submissions_by_status[submission.status].push(submission.id)
        state.submission_count++
      }
    },
    SET_LOADING: function (state, value) {
      if (typeof value === "boolean") state.loading = value
    },
    ...resetMixin.mutations,
  },
  actions: {
    RESET: function ({ commit }) {
      commit("RESET", initialState())
    },
    UPDATE_SUBMISSION: function ({ commit }, { submission, last_status }) {
      if (typeof submission.status_history === "string")
        submission.status_history = JSON.parse(submission.status_history)
      commit("REMOVE_SUBMISSION", {
        submission_id: submission.id || submission.pk,
        last_status:
          last_status ||
          submission.status_history[submission.status_history.length - 1] ||
          "Se",
      })
      commit("ADD_SUBMISSION", submission)
    },
    FETCH_SUBMISSIONS_BY_STATUS: async function (
      { commit, dispatch, state },
      config
    ) {
      if (!config) config = {}
      if (typeof config.offset !== "number") config = { offset: 0, ...config }
      if (typeof config.limit !== "number") config = { limit: 24, ...config }
      if (typeof config.status !== "string")
        config = { status: "Se", ...config }
      if (typeof config.stopAtStatus === "string")
        config.stopAtStatus = [config.stopAtStatus]
      if (typeof config.stopAtStatus !== "object") config.stopAtStatus = []
      if (typeof config.noNext !== "boolean") config.noNext = false

      try {
        const timestamp = new Date().getTime()
        const url =
          "/submission/dashboard/?limit=" +
          config.limit +
          "&offset=" +
          config.offset +
          "&status=" +
          config.status +
          "&time=" +
          timestamp
        const submissions = await this.$axios.$get(url)
        const count = submissions.count
        const next = submissions.next
        const batch = {}

        for (var i = submissions.results.length - 1; i >= 0; i--) {
          const submission = submissions.results[i]

          if (!state.submissions[submission.id]) {
            if (submission.status_history && submission.status_history.length)
              submission.status_history = JSON.parse(submission.status_history)
            batch[submission.id] = submission
          }
        }
        commit("MERGE_SUBMISSIONS_FROM_BATCH", { batch, status: config.status })
        config.offset += config.limit
        if (process.client && !config.noNext) {
          const currentStatusIndex = state.status_priority.indexOf(
            config.status
          )

          if (next) dispatch("FETCH_SUBMISSIONS_BY_STATUS", config)
          else if (currentStatusIndex < state.status_priority.length - 1) {
            if (
              config.stopAtStatus.indexOf(
                state.status_priority[currentStatusIndex + 1]
              ) === -1
            ) {
              config.status = state.status_priority[currentStatusIndex + 1]
              config.offset = 0
              dispatch("FETCH_SUBMISSIONS_BY_STATUS", config)
            }
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
  getters: {
    GET_SUBMISSION_FROM_ID: function (state) {
      return function (submission_id) {
        const ret = state.submissions[submission_id]
        return ret
      }
    },
  },
}
